export enum AmountOfDirectors {
    Single,
    Multiple
}

export enum TypeOfActivity {
    Main,
    Secondary
}

export enum EstimatedResult {
    MoreThan20k,
    LessThan20k
}

export enum PrivateAssets {
    Protected,
    Unprotected
}

export enum ActivityDuration {
    MoreThan3Years,
    LessThan3Years
}

export enum CompanyType {
    Bv,
    Commv,
    Vof,
    Emz
}